export const strandLossesColors = {
  categoryFallback: "#ccc",
  targetedRow: "lightblue",
  treePickerBorder: "#3F51B5",
  unclassifiedRow: "#E8C8C8",
} as const;
